<form [formGroup]="form" novalidate>

    <div class="row">
        <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Date Range</label>
                <div class="col-sm-9">
                    <div class="row">
                        <div class="col">
                            <input type="date" formControlName="startdate" class="form-control form-control-sm"
                                placeholder="Start Date">
                        </div>
                        <div class="col-1 p-0">
                            &nbsp; &nbsp;<span>_</span>&nbsp;&nbsp;
                        </div>
                        <div class="col">
                            <input type="date" formControlName="enddate" class="form-control form-control-sm"
                                placeholder="End Date">
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Total Range</label>
                <div class="col-sm-9" style="display:flex;">
                    <input type="text" formControlName="startrange" class="form-control form-control-sm"
                        placeholder="Start Range">
                    &nbsp; &nbsp;<span>_</span>&nbsp;&nbsp;
                    <input type="text" formControlName="endrange" class="form-control form-control-sm"
                        placeholder="End Range">
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Credit Note NO</label>
                <div class="col-sm-9">
                    <input type="text" formControlName="credit_notes_no" class="form-control form-control-sm"
                        placeholder="Credit Note NO">
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Customer Name</label>
                <div class="col-sm-9">
                     <app-multiautocomplete [options]="customerID" [control]="CustomersFormControl" text="" id="id" formControlName="customer_id"
                objectName="user-root" param1="customer_code" param2="name" (selectionchanged)="selectionchangedCustomer()" >
              </app-multiautocomplete>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Customer Ref. NO</label>
                <div class="col-sm-9">
                    <input type="text" formControlName="customer_ref_no" class="form-control form-control-sm"
                        placeholder="Customer Refernce No">
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">{{domain == 'presales.nfpc.net' || domain == 'merchandising' ?
                    'Merchandiser' : 'Salesman'}}</label>
                <div class="col-sm-9">
                     <!-- <app-multiautocomplete isSingle="true" objectName="code-root" [options]="salesmanList" formControlName="salesman" [control]="SalesmanFormControl"
             
            id="id" text="salesman"  (selectionchanged)="selectionchangedSalesman()">
          </app-multiautocomplete> -->
              <!-- <app-multiautocomplete isSingle="false" [options]="salesmanList"  [control]="SalesmanFormControl"
                                    formControlName="salesman" text="salesman_name" id="id" objectName="code-root"
                                    placeholder="Search Salesman">
                                </app-multiautocomplete> -->
                                 <app-multiautocomplete isSingle="false" [options]="salesmanList" (selectionchanged)="selectionchangedSalesman()"
                                    [control]="SalesmanFormControl" text="salesman_name" id="id"
                                    placeholder="Search Salesman">
                                </app-multiautocomplete>
                                <!-- <app-multiautocomplete isSingle="false" [options]="salesmanList" (selectionchanged)="selectionchangedSalesman()"
                                    [control]="SalesmanFormControl" text="" id="id" param1="salesman_code"
                                    param2="name" objectName="user-root"
                                    placeholder="Search Salesman">
                                </app-multiautocomplete> -->
                                 <!-- <app-multiautocomplete  isSingle="false" [options]="salesman" [control]="selectionchangedSalesman" text="" id="id" formControlName="customer_id"
                objectName="user-root" param1="customer_code" param2="name" (selectionchanged)="selectionchangedCustomer()" >
              </app-multiautocomplete> -->
                    <!-- <mat-select class="form-control form-control-sm" formControlName="salesman">
                        <mat-option *ngFor="let item of salesman" [value]="item.id">
                            {{ item.firstname }} {{ item.lastname }}
                        </mat-option>
                    </mat-select> -->
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <!-- <div class="form-group row">
                <label class="col-sm-3 col-form-label">Status</label>
                <div class="col-sm-9">
                    <mat-select class="form-control form-control-sm" formControlName="current_stage">
                        <mat-option *ngFor="let item of statusList" [value]="item.id">
                            {{ item.name }}
                        </mat-option>
                    </mat-select>
                </div>
            </div> -->
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Service Channel</label>
                <div class="col-sm-9">
                     <mat-select multiple class="form-control form-control-sm" formControlName="channel_name">
                                    <mat-option *ngFor="let item of channelList" [value]="item.id">
                                    {{ item?.name }}
                                    </mat-option>
                                </mat-select>
                </div>
            </div>
        </div>
         <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Item</label>
                <div class="col-sm-9">
                     <app-multiautocomplete isSingle="false" [options]="filteredItems" [control]="itemsFormControl" text="" formControlName="item_id"
                  id="id" objectName="item-portfolio-root" (selectionchanged)="selectionchangedItems()" param1="item_code"
                  param2="item_name">
                </app-multiautocomplete>
                </div>
            </div>
        </div>
         <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Status</label>
                <div class="col-sm-9">
                    <!-- <mat-select multiple class="form-control form-control-sm" formControlName="erp_status">
                        <mat-option *ngFor="let item of statusList" [value]="item.id">
                          {{ item.name }}
                        </mat-option>
                      </mat-select> -->
                       <mat-select multiple class="form-control form-control-sm" formControlName="erp_status">
              <mat-option value="Requested">Requested</mat-option>
              <mat-option value="Truck Allocated">Truck Allocated </mat-option>
              <mat-option value="Completed">Completed </mat-option>
            </mat-select>
         
                </div>
            </div>
        </div>
          <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Approval Status</label>
                <div class="col-sm-9">
                     <mat-select multiple class="form-control form-control-sm" formControlName="approval_status">
              <mat-option value="Approved">Approved</mat-option>
              <mat-option value="Reject">Reject</mat-option>
              <mat-option value="Pending">Pending</mat-option>
            </mat-select>
                </div>
            </div>
        </div>
         <!-- <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Assigned</label>
                <div class="col-sm-9">
                  
                       <mat-select multiple class="form-control form-control-sm" formControlName="erp_status">
              <mat-option value="Requested">Requested</mat-option>
              <mat-option value="Truck Allocated">Truck Allocated </mat-option>
              <mat-option value="Completed">Completed </mat-option>
            </mat-select>
         
                </div>
            </div>
        </div> -->
    </div>
</form>